import ProcessDefinitionKeys from 'app/components/organisms/ProcessDefinitionKeys/ProcessDefinitionKeys';
import { PRIORITY_FILTER_OPTIONS } from 'app/config/aboxConfig';
import { get } from 'app/utils/lo/lo';

export const tasksFilterDefinitions = [
    {
        field: 'primary.assignee',
        type: 'userTypeahead',
        properties: {
            label: 'Assignee',
            name: 'assigneeId',
            multiple: true,
            disabled: data => get(data, 'assigneeIdNull') !== null,
            valueField: 'id',
            includeDisabledUsers: true,
        },
        condition: 'in',
    },
    {
        field: 'primary.assignee',
        type: 'typeahead',
        properties: {
            label: 'Is assigned?',
            name: 'assigneeIdNull',
            options: [
                { value: null, label: 'Any' },
                { value: 'is not null', label: 'Assigned to me' },
                { value: 'is null', label: 'Not assigned to me' },
                { value: 'isNotAssigne', label: 'No Assignee' },
            ],
            onChange: function onChange(event) {
                const value = event.target.value;
                return [
                    { name: 'assigneeIdNull', value },
                    { name: 'assigneeId', value: null },
                ];
            },
            defaultValue: null
        },
        sort: false,
    },
    {
        field: 'primary.definitionElementId',
        type: 'custom',
        properties: {
            label: 'Key',
            name: `primaryDefinitionElementId`,
            Component: ProcessDefinitionKeys,
        },
        valueField: 'value',
    },
    {
        field: 'primary.sequenceNumber',
        type: 'number',
        properties: {
            label: 'Sequence Number',
            name: 'primarySequenceNumber',
        },
        condition: '=',
        toTextValue: true,
    },
    {
        field: 'name',
        type: 'text',
        properties: {
            label: 'Name',
            name: 'name',
            opSelector: true,
        },
    },
    {
        field: 'process.name',
        type: 'text',
        properties: {
            label: 'Process name',
            name: 'process.name',
            opSelector: true,
        },
        sort: false,
        filters: false,
    },
    {
        field: 'id',
        type: 'uuid',
        properties: {
            label: 'ID',
            name: 'id',
            opSelector: true,
        },
        condition: '=',
    },
    {
        field: 'classes.id',
        type: 'classificationTypeahead',
        properties: {
            label: 'Classes',
            name: 'classesUri',
            filterBy: [
                { field: 'active', op: '=', value: true },
                { field: 'abstract', op: '=', value: false },
                { field: 'primary', op: '=', value: false },
                { field: 'applicableOn', op: 'overlaps', value: ['entity', 'system_task'] },
            ],
            multiple: true,
            valueField: 'id',
        },
        condition: 'in',
        sort: false,
    },
    {
        field: 'relations.relatedEntity.id',
        type: 'relatedEntities',
        properties: {
            label: 'Related Entities',
            name: 'relatedEntities',
        },
        condition: 'in',
        sort: false,
    },
    {
        field: 'type',
        type: 'typeahead',
        properties: {
            label: 'Task Status',
            name: 'statusType',
            options: [
                { value: null, label: 'Any' },
                { value: 'opentask', label: 'Open' },
                { value: 'closedtask', label: 'Closed' },
            ],
            onChange: function onChange(event, ...args) {
                const value = event.target.value;
                if (value !== 'closedtask') {
                    return [event.target, { name: 'taskClosedDate', value: null }];
                }
                return event.target;
            },
        },
        sort: false,
        condition: '=',
    },
    {
        field: 'primary.priority',
        type: 'typeahead',
        properties: {
            label: 'Priority',
            name: 'priority',
            options: PRIORITY_FILTER_OPTIONS,
            valueField: 'value',
        },
        condition: '=',
    },
    {
        field: 'process.processDefinition.id',
        type: 'processTypeTypeahead',
        properties: {
            label: 'Process Types',
            name: 'processDefinitionName',
            multiple: true,
            filterBy: [{ field: 'active', op: '=', value: true }],
        },
        condition: 'in',
    },
    {
        field: 'process.primary.variables.INITIATOR',
        type: 'userTypeahead',
        properties: {
            label: 'Process started by',
            name: 'processInitiator',
            multiple: true,
            valueField: 'id',
            includeDisabledUsers: true,
        },
        sort: false,
        condition: 'in',
    },
    {
        field: 'primary.startDate',
        type: 'typeahead',
        properties: {
            label: 'Is start date set?',
            name: 'primaryStartDate',
            options: [
                { value: null, label: 'Any' },
                { value: 'is not null', label: 'Yes' },
                { value: 'is null', label: 'No' },
            ],
            valueField: 'value',
            onChange: (event, ...args) => {
                const value = event.target.value;
                if (value && value === 'is null') {
                    return [
                        { name: 'primaryStartDate', value },
                        { name: 'primaryStartDateTime', value: null },
                    ];
                } else {
                    return { name: 'primaryStartDate', value };
                }
            },
        },
        sort: false,
    },
    {
        field: 'primary.startDate',
        type: 'dateTimeRange',
        properties: {
            label: 'Start date',
            name: 'primaryStartDateTime',
            disabled: data => get(data, 'primaryStartDate') === 'is null'
        },
    },
    {
        field: 'primary.dueDate',
        type: 'typeahead',
        properties: {
            label: 'Is due date set?',
            name: 'dueDateNull',
            options: [
                { value: null, label: 'Any' },
                { value: 'is not null', label: 'Yes' },
                { value: 'is null', label: 'No' },
            ],
            valueField: 'value',
            onChange: function onChange(event, ...args) {
                const value = event.target.value;
                if (value && value === 'is null') {
                    return [
                        { name: 'dueDateNull', value },
                        { name: 'dueDate', value: null },
                    ];
                } else {
                    return { name: 'dueDateNull', value };
                }
            },
        },
        sort: false,
    },
    {
        field: 'primary.dueDate',
        type: 'dateTimeRange',
        properties: {
            label: 'Due date',
            name: 'dueDate',
            disabled: data => get(data, 'dueDateNull') === 'is null',
        },
    },
    {
        field: 'modifiedBy',
        type: 'userTypeahead',
        properties: {
            label: 'Modified by',
            name: 'modifiedById',
            multiple: true,
            valueField: 'id',
            includeDisabledUsers: true,
        },
        condition: 'in',
        filters: false,
    },
    {
        field: 'createdBy',
        type: 'userTypeahead',
        properties: {
            label: 'Created by',
            name: 'createdById',
            multiple: true,
            valueField: 'id',
            includeDisabledUsers: true,
        },
        condition: 'in',
        filters: false,
    },
    {
        field: 'modifiedDate',
        type: 'dateTimeRange',
        properties: {
            label: 'Last updated',
            name: 'taskStatusLastUpdate',
        },
    },
    {
        field: 'createdDate',
        type: 'dateTimeRange',
        properties: {
            label: 'Created date',
            name: 'createdDate',
        },
    },
    {
        field: 'primary.closedDate',
        type: 'dateTimeRange',
        properties: {
            label: 'Closed date',
            name: 'taskClosedDate',
            onChange: function onChange(event, ...args) {
                return [event.target, { name: 'statusType', value: 'closedtask' }];
            },
        },
    },
];

export const tasksDefaultFilters = { statusType: 'opentask', active: true, dueDateNull: null, primaryStartDate: null, assigneeIdNull: null, priority: null };

export const tasksDefaultOrder = [{ field: 'modifiedDate', direction: 'desc nulls last' }];